<template>
  <div>
    <p>Browse and search through all processed messages in your system:</p>
    <ul>
      <li><strong>Message List</strong> - View all messages in a searchable list</li>
      <li><strong>Advanced Filtering</strong> - Filter messages by endpoint, time range, and more</li>
      <li><strong>Full-text Search</strong> - Search message contents to find specific data</li>
      <li><strong>Sorting Options</strong> - Sort by time processed, endpoint, or message type</li>
      <li><strong>Auto Refresh</strong> - Keep your message list up to date with the latest processed messages</li>
    </ul>
  </div>
</template>
